import { Box, Chip } from "@mui/material";

import { AreaSummary, MarketSummary } from "../../types/response/summary";
import { isAreaManager, isMarketManager } from "../../utils/role/isRole";

type UserWithManagedSummary = {
  managedAreas: AreaSummary[];
  managedMarkets: MarketSummary[];
  role: string;
};

type ManagedChipsProps = {
  user: UserWithManagedSummary;
};

const ManagedChips = ({ user }: ManagedChipsProps) => {
  if (isAreaManager(user.role)) {
    return (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {user.managedAreas.map((m) => (
          <Chip
            key={m.areaId}
            label={m.areaName}
            color="default"
            variant="outlined"
          />
        ))}
      </Box>
    );
  }
  if (isMarketManager(user.role)) {
    return (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {user.managedMarkets.map((m) => (
          <Chip
            key={m.marketId}
            label={m.marketName}
            color="default"
            variant="outlined"
          />
        ))}
      </Box>
    );
  }
  return null;
};

export default ManagedChips;
